import styled from 'styled-components'
import Modal from 'react-modal'
import {
  GRAY_SCALE_03,
  PRIMARY_BLUE_03,
} from 'bd-web-components/src/utils/dash-colors'

export const StyledModal = styled(Modal)`
  position: absolute;
  inset: 40px;
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  overflow: auto;
  border-radius: 10px;
  outline: none;
  padding: 30px 20px;
  margin: auto;
  max-width: 524px;
  max-height: 450px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 768px) {
    position: fixed;
    max-height: 100%;
    max-width: 100%;
    padding: 100px 24px;
    inset: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
    border-radius: 0px;
    overflow-y: auto;
  }
`

export const PageTitle = styled.h4`
  color: ${PRIMARY_BLUE_03};
  margin-bottom: 16px;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
`

export const PageSubtitle = styled.p`
  color: ${GRAY_SCALE_03};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
export const BeforeDiv = styled.div`
  margin-bottom: 30px;
  height: 10px;
  display: flex;
  justify-content: center;
  flex: 1;
  @media (max-width: 768px) {
    max-height: 80px;
  }
`

export const GifBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px auto;
  margin-bottom: 10px;
  width: 328px;
  @media (max-width: 768px) {
    width: 256px;
    margin: 28px auto;
    margin-bottom: 5px;
  }
`

export const ButtonBox = styled.div`
  margin-top: 30px;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`
